const TOKEN_KEY = "trace-web-token";
const REFRESH_TOKEN_KEY = "trace-web-refresh-token";
const ACCESS_EXPIRES_AT_MS_KEY = "trace-web-access-expires-at-ms";

/**
 * Access JWT en sessionStorage.
 * Refresh opaco en clave aparte (`trace-web-refresh-token`); usar `clearAuthStorage` al cerrar sesión.
 */
export function getStoredToken(): string | null {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setStoredToken(token: string): void {
  sessionStorage.setItem(TOKEN_KEY, token);
}

export function getStoredRefreshToken(): string | null {
  try {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setStoredRefreshToken(refreshToken: string): void {
  sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
}

export function getStoredAccessExpiresAtMs(): number | null {
  try {
    const raw = sessionStorage.getItem(ACCESS_EXPIRES_AT_MS_KEY);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

export function setStoredAccessExpiresAtMs(expiresAtMs: number): void {
  sessionStorage.setItem(ACCESS_EXPIRES_AT_MS_KEY, String(Math.floor(expiresAtMs)));
}

export function clearStoredToken(): void {
  sessionStorage.removeItem(TOKEN_KEY);
}

export function clearStoredRefreshToken(): void {
  sessionStorage.removeItem(REFRESH_TOKEN_KEY);
}

/** Quita access + refresh del almacenamiento local. */
export function clearAuthStorage(): void {
  try {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    sessionStorage.removeItem(ACCESS_EXPIRES_AT_MS_KEY);
  } catch {
    /* ignore */
  }
}
